import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Stack, styled, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { AppReg } from "../../assets/Svg";
import {
  deleteBillByClient,
  deleteBillZkTraders,
  getClientById,
  getData,
  loginAdmin,
} from "../../apiservices";
import { toast } from "react-toastify";
import moment from "moment";
import { CustomToolbar } from "../categories/categoryTable";
import CustomDialogue from "../reuseableComp/Modal";
import { Typo } from "../bank";
const Btn = styled(Button)({
  textTransform: "none",
  background: "#EEF4FF",
  color: "#05B905",
  "&:hover": {
    color: "#000",
    background: "#05B905",
  },
});

export default function DataTable({
  addSales,
  view,
  rowData,
  getBillData,
  clientData,
}) {
  const [state, setState] = React.useState({
    password: "",
    isDelete: false
  });

  const columns = [
    { field: "date", headerName: "Date" },
    { field: "show_voucher_no", headerName: "Invoice#", width: 150 },
    { field: "client_name", headerName: "Client", width: 300 },
    // { field: "clientName", headerName: "Client", width: 250 },
    // {
    //   field: "seller",
    //   headerName: "Seller",
    //   width: 150,
    // },
    {
      field: "amount",
      headerName: "Total Amount",
      sortable: true,
      width: 150,
      valueFormatter: (params) => `Rs ${params.value}`
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <>
          <Btn
            sx={{ height: '30px', mr: '5px', padding: 0 }}
            variant="contained"
            color="primary"
            size="small"
            onClick={() => view(params.row)}>
            View Bill
          </Btn>
          <Btn
            title="Edit"
            variant="contained"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "#eed202", color: "white" }}
            onClick={() => addSales(params.row)}>
            {/* <AppReg /> */}
            <EditIcon fontSize="small" />
          </Btn>
          <Btn
            title="Delete"
            sx={{ width: '30px', height: '30px', minWidth: '30px', mr: '5px', padding: 0, background: "red", color: "white" }}
            variant="contained"
            onClick={() => deleteRow(params.row)}>
            <DeleteIcon fontSize="small" />
          </Btn>
        </>
      ),
    },
  ];
  const rows = rowData !== undefined ? rowData : [];
  const deleteRow = async (params) => {
    /* eslint-disable no-restricted-globals */
    setState((prev) => ({
      ...prev,
      isDelete: true,
      voucher_no: params.voucher_no,
    }));
  };
  return (
    <div style={{ height: "80vh", width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 20 },
          },
        }}
        pageSizeOptions={[20, 50, 100]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
      <CustomDialogue
        open={state.isDelete}
        handleClose={() => { }}
        header={
          <Stack justifyContent={"center"} alignItems={"center"}>
            <Typo>Deletion</Typo>
          </Stack>
        }
        content={
          <>
            <Stack sx={{ padding: 1 }}>
              <Stack sx={{ mt: 2 }}>
                <Typography>Please enter password if you really want to delete <strong>{`Invoice#"${state.voucher_no}"`}</strong>.</Typography>
                <input onChange={(e) => {
                  setState((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }));
                }} type="password" />
              </Stack>
            </Stack>
            <div style={{ float: "right" }}>
              <Btn
                sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0, background: "red", color: "white" }}
                variant="contained"
                size="small"
                onClick={async () => {
                  let userData = JSON.parse(localStorage.getItem("user"));
                  let credentials = {
                    username: userData.username,
                    password: state.password,
                  };
                  let resUser = await loginAdmin(credentials);
                  if (resUser.success) {
                    let res = await deleteBillZkTraders(state.voucher_no);
                    if (res.success) {
                      toast.success("Sale deleted successfully");
                      getBillData();
                      setState((prev) => ({
                        ...prev,
                        isDelete: false,
                      }));
                    }
                  }
                  else {
                    toast.error("Wrong password...!")
                  }
                }}
              >Delete</Btn>
              <Btn
                sx={{ height: '30px', mt: '10px', mr: '5px', padding: 0 }}
                variant="contained"
                color="error"
                size="small"
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    isDelete: false,
                  }));
                }}
              >Close</Btn>
            </div>
          </>
        }
      />
    </div>
  );
}
